export default {
    computed: {
        portfolio()
        {
            return this.$store.getters['portfolio/coins'];
        },

        prices()
        {
            return this.$store.getters['prices/all'];
        }
    },

    methods: {
        coinInBtc( pCoin )
        {
            if( !this.prices )
            {
                return 0;
            }

            if( pCoin === 'btc' )
            {
                return this.portfolio[ pCoin ];
            }
            else if( pCoin === 'ltc' )
            {
                if( !this.prices.XBTUSD )
                {
                    return 0;
                }

                return this.prices[pCoin.toUpperCase() + 'USD'] / this.prices.XBTUSD * this.portfolio[ pCoin ];
            }
            else
            {
                if( !this.prices.XBTUSD || !this.prices[pCoin.toUpperCase() + 'BTC'] )
                {
                    return 0;
                }

                return this.portfolio[ pCoin ] * this.prices[pCoin.toUpperCase() + 'BTC'];
            }
        }
    }
};
